module.exports = __webpack_public_path__ + "static/media/55_000017.21b31786.jpg";